import { useEffect, useState } from 'react';

import * as style from './SocialMediaLoginCss';
import { openWindow, observeWindow } from './Utils';
import { obtainOauthAccessToken } from '../../services/apiRequests/SocialMediaLogin/oauthService';
import { LOGIN_REGISTER_TEXT } from '../../utils/constants/stringConstants';

type TwitterLoginProps = {
  consumerKey: string;
  consumerSecret: string;
  authCallback: (err: string | null | undefined, data: any) => void;
  callbackUrl?: string;
};

const TwitterLoginComponent = ({
  consumerKey,
  consumerSecret,
  authCallback,
  callbackUrl
}: TwitterLoginProps) => {
  const [isCompleted, setCompleted] = useState(false);
  const [popUp, setPopUp] = useState<Window | null>(null);

  useEffect(() => {
    initializeProcess();
  }, []);

  const initializeProcess = () => {
    if (window.opener) {
      const [, oauthToken, oauthVerifier] =
        window.location.search.match(
          /^(?=.*oauth_token=([^&]+)|)(?=.*oauth_verifier=([^&]+)|).+$/
        ) || [];
      window.opener.postMessage(
        {
          type: 'authorized',
          data: {
            oauthToken,
            oauthVerifier
          }
        },
        window.origin
      );
    } else {
      window.onmessage = async ({ data: { type, data } }: any) => {
        if (type === 'authorized') {
          const accessTokenData = await obtainOauthAccessToken({
            apiUrl: 'https://api.twitter.com/oauth/access_token',
            consumerKey,
            consumerSecret,
            oauthToken: data.oauthToken,
            oauthVerifier: data.oauthVerifier,
            method: 'POST'
          });
          setCompleted(true);
          authCallback && authCallback(undefined, accessTokenData);
          popUp && popUp.close();
        }
      };
    }
  };

  const handleLoginClick = async () => {
    const popup = openWindow({
      url: ``,
      name: 'Log in with Twitter'
    });

    if (callbackUrl) {
      console.warn(
        `DEPRECATED: "callbackUrl" is not supported and ignored from version 1.2.0 and higher. It's hardcoded inside the package with "window.location.href". More details: https://github.com/alexandrtovmach/react-twitter-login/issues/8`
      );
    }

    const twitterToken = await fetch('../../api/twitter/requestToken');
    const requestTokenData = await twitterToken.json();
    if (
      requestTokenData?.token?.oauth_callback_confirmed === 'true' &&
      popup !== null
    ) {
      popup.location.href = `https://api.twitter.com/oauth/authorize?oauth_token=${requestTokenData.token.oauth_token}`;

      if (popup) {
        observeWindow({ popup, onClose: handleClosingPopup });
        setPopUp(popup);
      }
    } else {
      handleError(
        `Callback URL "${window.location.href}" is not confirmed. Please check that is whitelisted within the Twitter app settings.`
      );
    }
  };

  const handleClosingPopup = () => {
    if (!isCompleted) {
      authCallback && authCallback('User closed OAuth popup', {});
    }
  };

  const handleError = (message: string) => {
    authCallback(message, {});
  };

  return (
    <div
      data-test-id="socialIcons"
      className="loginSocialIcon socialTwitterLogin"
      css={style.socialIcons}
      id="twitter-Login"
      onClick={handleLoginClick}>
      <img
        src="/webapp-assets/images/twitter-social-icon.svg"
        alt={LOGIN_REGISTER_TEXT.TWITTER}
      />
    </div>
  );
};

export default TwitterLoginComponent;
